import { inject, Injectable } from '@angular/core';
import { SERVICE_STORE } from '../../domain/tokens/service-store.token';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceDrawerChangedEvent } from '@platform/event-bus/domain/events/service-drawer.event';

@Injectable({ providedIn: 'root' })
export class ChangeDrawerUseCase {
  private readonly serviceStore = inject(SERVICE_STORE);
  private readonly eventBus = inject(EVENT_BUS);

  execute(): void {
    const state = this.serviceStore.state();
    const isWorkersOwnedDevice = state.isWorkersOwnedDevice;
    const currentSelection = state.selection ?? {
      location: null,
      drawer: null,
      worker: null,
    };

    if (isWorkersOwnedDevice) {
      this.serviceStore.setSelection({
        ...currentSelection,
        drawer: null,
      });
    } else {
      this.serviceStore.setSelection({
        ...currentSelection,
        drawer: null,
        worker: null,
      });
    }

    this.eventBus.publish(new ServiceDrawerChangedEvent());
  }
}